module.exports = __webpack_public_path__ + "static/media/Hot.eb5dbf68.svg";